import { GetServerSidePropsContext } from 'next';

import { BeekUserRole } from 'src/utils/user';
import {
  setAudiobookIdServerSide,
  setAuthTokenServerSide,
  setLoginTokenSucceed,
} from 'src/app/auth/cookiesServerSide';
import {
  setAuthToken,
  setUserRole as setUserRoleCookie,
} from 'src/app/auth/cookies';

const setUserInfo = (token: string): void => setAuthToken(token);

export const setUserInfoServerSide = (
  token: string,
  context: GetServerSidePropsContext
): void => setAuthTokenServerSide(token, context);

export const setLoginTokenSucceedServerSide = (
  succeed: boolean,
  context: GetServerSidePropsContext
): void => setLoginTokenSucceed(succeed, context);

export const setAudiobookId = (
  audiobook_id: string,
  context: GetServerSidePropsContext
): void => setAudiobookIdServerSide(audiobook_id, context);

export const setUserRole = (role: BeekUserRole): void =>
  setUserRoleCookie(role);

export default setUserInfo;
